import { useContext } from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { Language } from '../../App';

const ThankYouModal = ({ isOpen, toggle }) => {
  const languageContext = useContext(Language);
  const { lang } = languageContext || { lang: {} };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="text-center p-3">
        <h4 className="fw-bold text-dark mb-3">{lang?.feedback_received}</h4>
        <p className="text-secondary mb-4">
         {lang?.thank_you_for_feedback}
        </p>
        <Button
          color="dark"
          onClick={toggle}
          className="w-100 mt-3"
        >
          {lang?.new_okay}
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default ThankYouModal;
